import { backgroundColors } from '../Section/background';
import { COLOR_KEYS } from '../../constants';
export const zapCardSectionConfig = {
    name: 'ZapCardSection',
    image: 'https://cdn.zappy.app/4e1f43386cebbdb10a527efc33a74804.png',
    includeScrollTracking: true,
    category: 'Zapier Sections',
    inputs: [
        {
            name: 'layout',
            type: 'string',
            enum: ['card', 'mega', 'auto'],
        },
        {
            name: 'background',
            type: 'string',
            enum: Object.keys(backgroundColors),
            defaultValue: COLOR_KEYS.transparent,
        },
        {
            name: 'items',
            type: 'list',
            subFields: [
                { name: 'zapTemplateID', type: 'string' },
                {
                    name: 'label',
                    type: 'string',
                    helperText: 'Label name.',
                },
                {
                    name: 'labelTooltip',
                    type: 'string',
                    helperText: 'Tooltip describing why the label was applied.',
                },
                {
                    name: 'href',
                    type: 'string',
                    helperText: 'URL to the shared Zap / template.',
                },
                {
                    name: 'title',
                    type: 'string',
                    helperText: 'Title of the Zap.',
                },
                {
                    name: 'services',
                    type: 'list',
                    subFields: [
                        {
                            name: 'name',
                            type: 'string',
                            defaultValue: 'Slack',
                            helperText: 'Service name.',
                        },
                        {
                            name: 'src',
                            type: 'cloudinaryImage',
                            defaultValue: 'https://images.zapier.com/storage/services/6cf3f5a461feadfba7abc93c4c395b33_2.128x128.png',
                            helperText: 'URL to the service icon.',
                        },
                    ],
                    helperText: 'Array of services used by the Zap. Used to display service icons.',
                },
                {
                    name: 'color',
                    type: 'color',
                    helperText: 'Color of the card.',
                },
            ],
        },
    ],
};
//# sourceMappingURL=config.js.map